
















































import {
    Vue,
    Component
} from "@/shared/vuepack";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import { useWexDebitCardsStore } from "@/shared/store/wexDebitCards";
import WexDebitCardNewCardRequestModal from "@/employee/components/settings/wexDebitCards/WexDebitCardNewCardRequestModal.vue";
import WexDebitCardManageCardModal from "@/employee/components/settings/wexDebitCards/WexDebitCardManageCardModal.vue";
import { CardWexRecord, WexDebitCardManageCardViewState } from "@/shared/types";

@Component({
    components: {
        SettingsHeader,
        SettingsNavigation,
        WexDebitCardNewCardRequestModal,
        WexDebitCardManageCardModal
    }
})
export default class WexDebitCards extends Vue {
    wexDebitCardsStore = useWexDebitCardsStore();

    confirmNewCardRequestModalVisible = false;
    confirmManageCardRequestModalVisible = false;
    rowSelected = null;

    mounted (): void {
        this.wexDebitCardsStore.getWexDebitCards();
    }

    tableFields = [
        {
            key: "firstName",
            label: "Name"
        },
        {
            key: "cardNumberLast4",
            label: "Card Number"
        },
        {
            key: "cardStatus",
            label: "Card Status"
        },
        {
            key: "isPinSet",
            label: "Pin Status"
        },
        {
            key: "actions",
            label: ""
        }
    ];

    manageCardClicked (row: CardWexRecord) {
        this.wexDebitCardsStore.setDebitCardRowSelected(row);
        this.wexDebitCardsStore.setWexDebitCardManageCardViewState(WexDebitCardManageCardViewState.ManageCardForm);
        this.wexDebitCardsStore.setManageCardModalOpen(true);
    }
}

